export default defineAppConfig({
  icon: {
    mode: "svg",
    aliases: {
      "project-task": "ph:chat-teardrop-text",
      "project-task-duotone": "ph:chat-teardrop-text-duotone",
    },
  },
});
